import { getIconPathString } from "components/icons/imdf-category-icon-paths"

const BASE_FONT_FAMILY = "Manrope"

const defaultMapTheme = [
  {
    featureType: "origin-marker",
    elementType: "geometry",
    symbol: [
      {
        markerType: "ellipse",
        markerFill: "#000000",
        markerLineWidth: 0,
        markerFillOpacity: 0.1,
        markerWidth: 30,
        markerHeight: 30,
      },
      {
        markerType: "ellipse",
        markerFill: "#ffffff",
        markerLineColor: "#000000",
        markerLineWidth: 2,
        markerWidth: 15,
        markerHeight: 15,
      },
    ],
  },
  {
    featureType: "navigation-path",
    elementType: "geometry",
    symbol: [
      {
        lineColor: "#6393f2",
        lineOpacity: 0.2,
        lineCap: "round",
        lineJoin: "round",
        lineWidth: {
          stops: [
            [18, 6],
            [20, 8],
          ],
        },
      },
      {
        lineColor: "#6393f2",
        lineOpacity: 1,
        lineCap: "round",
        lineJoin: "round",
        lineWidth: {
          stops: [
            [18, 3],
            [20, 4],
          ],
        },
      },
    ],
  },
  {
    featureType: "navigation-path-start",
    elementType: "geometry",
    symbol: {
      markerType: "ellipse",
      markerWidth: {
        stops: [
          [17, 4],
          [18, 6],
        ],
      },
      markerHeight: {
        stops: [
          [17, 4],
          [18, 6],
        ],
      },
      markerLineWidth: 1,
      markerLineColor: "#6393f2",
      markerFill: "#fff",
      markerPlacement: "vertex-first",
    },
  },
  {
    featureType: "navigation-path-end",
    elementType: "geometry",
    symbol: {
      markerType: "ellipse",
      markerWidth: {
        stops: [
          [17, 4],
          [18, 6],
        ],
      },
      markerHeight: {
        stops: [
          [17, 4],
          [18, 6],
        ],
      },
      markerLineWidth: 1,
      markerLineColor: "#6393f2",
      markerFill: "#fff",
      markerPlacement: "vertex-last",
    },
  },
  {
    featureType: "pin-marker",
    elementType: "geometry",
    symbol: {
      markerType: "path",
      markerPath: `M5.7,15.1L5.7,15.1C5.6,15,4.3,13.5,3,11.6c-0.7-1-1.3-2-1.8-3.1c-0.5-1.1-0.8-2.1-0.8-3c0-2.9,2.5-5.3,5.5-5.3  c3,0,5.5,2.4,5.5,5.3c0,0.9-0.3,1.9-0.8,3c-0.5,1.1-1.1,2.1-1.8,3.1c-1.3,1.9-2.7,3.4-2.8,3.5l0,0C6,15.2,5.8,15.2,5.7,15.1z   M2.7,5.6c0,1.7,1.5,3.1,3.2,3.1c1.8,0,3.2-1.4,3.2-3.1c0-1.7-1.5-3.1-3.2-3.1S2.7,3.9,2.7,5.6z M8.2,22.1c0,1.2-1,2.2-2.3,2.2c-1.3,0-2.3-1-2.3-2.2c0-1.2,1-2.2,2.3-2.2C7.2,20,8.2,20.9,8.2,22.1z`,
      markerFill: "#FF0000",
      markerPathWidth: 12,
      markerPathHeight: 25,
      markerLineWidth: 0.5783,
      markerLineColor: "#fff",
      markerWidth: {
        stops: [
          [18, 12],
          [19, 24],
          [20, 36],
        ],
      },
      markerHeight: {
        stops: [
          [18, 25],
          [19, 50],
          [20, 75],
        ],
      },
    },
  },
  {
    featureType: "hilight-polygonal",
    elementType: "geometry",
    symbol: { polygonFill: "#787878" },
  },
  {
    featureType: "hilight-marker",
    elementType: "geometry",
    symbol: [
      {
        markerWidth: {
          stops: [
            [18, 5],
            [19, 25],
            [20, 45],
          ],
        },
        markerHeight: {
          stops: [
            [18, 5],
            [19, 25],
            [20, 45],
          ],
        },
      },
      {
        markerWidth: {
          stops: [
            [19, 10],
            [20, 35],
          ],
        },
        markerHeight: {
          stops: [
            [19, 10],
            [20, 35],
          ],
        },
        markerDy: -8,
      },
    ],
  },
  {
    featureType: "highlight-amenity-marker",
    elementType: "geometry",
    symbol: {
      markerType: "path",
      markerPath: `M5.7,15.1L5.7,15.1C5.6,15,4.3,13.5,3,11.6c-0.7-1-1.3-2-1.8-3.1c-0.5-1.1-0.8-2.1-0.8-3c0-2.9,2.5-5.3,5.5-5.3  c3,0,5.5,2.4,5.5,5.3c0,0.9-0.3,1.9-0.8,3c-0.5,1.1-1.1,2.1-1.8,3.1c-1.3,1.9-2.7,3.4-2.8,3.5l0,0C6,15.2,5.8,15.2,5.7,15.1z   M2.7,5.6c0,1.7,1.5,3.1,3.2,3.1c1.8,0,3.2-1.4,3.2-3.1c0-1.7-1.5-3.1-3.2-3.1S2.7,3.9,2.7,5.6z M8.2,22.1c0,1.2-1,2.2-2.3,2.2c-1.3,0-2.3-1-2.3-2.2c0-1.2,1-2.2,2.3-2.2C7.2,20,8.2,20.9,8.2,22.1z`,
      markerFill: "#FF0000",
      markerPathWidth: 12,
      markerPathHeight: 25,
      markerLineWidth: 0.5783,
      markerLineColor: "#fff",
      markerWidth: {
        stops: [
          [18, 12],
          [19, 24],
          [20, 36],
        ],
      },
      markerHeight: {
        stops: [
          [18, 25],
          [19, 50],
          [20, 75],
        ],
      },
    },
  },
  {
    featureType: "highlight-zone-unit",
    elementType: "geometry",
    symbol: {
      polygonFill: "rgba(130, 130, 130, 1)",
      lineColor: "#828282",
    },
  },
  {
    featureType: "user-location",
    elementType: "geometry",
    symbol: {
      start: [
        {
          markerType: "ellipse",
          markerFill: "#077dff",
          markerLineWidth: 0,
          markerFillOpacity: 0.2,
          markerWidth: 30,
          markerHeight: 30,
        },
        {
          markerType: "ellipse",
          markerFill: "#077dff",
          markerLineColor: "#ffffff",
          markerLineWidth: 2,
          markerWidth: 20,
          markerHeight: 20,
        },
      ],
      end: [
        {
          markerFillOpacity: 0.4,
          markerWidth: 40,
          markerHeight: 40,
        },
        {
          markerWidth: 20,
          markerHeight: 20,
        },
      ],
    },
  },
  {
    featureType: "last-user-location",
    elementType: "geometry",
    options: {
      text: "Last\nScanned",
    },
    symbol: [
      {
        markerType: "ellipse",
        markerFill: "#fff",
        markerLineWidth: 0,
        markerFillOpacity: 0.2,
        markerWidth: 30,
        markerHeight: 30,
      },
      {
        markerType: "ellipse",
        markerFill: "#A4A4A4",
        markerLineColor: "#ffffff",
        markerLineWidth: 2,
        markerWidth: 20,
        markerHeight: 20,
      },
      {
        textFaceName: BASE_FONT_FAMILY,
        textName: "{text}",
        textWeight: "normal",
        textStyle: "normal",
        textFill: "#666666",
        textHaloFill: "#ffffff",
        textLineSpacing: 0,
        textHaloRadius: {
          stops: [
            [20, 1],
            [21, 2],
          ],
        },
        textDy: {
          stops: [
            [19, -15],
            [20, -35],
          ],
        },
        textSize: {
          stops: [
            [19, 0],
            [20, 16],
            [22, 18],
          ],
        },
      },
    ],
  },
  {
    featureType: "venue",
    elementType: "geometry",
    symbol: {
      polygonFill: "rgba(213, 213, 213, 0.5)",
      lineWidth: 0,
    },
  },
  {
    featureType: "level",
    elementType: "geometry",
    symbol: {
      lineColor: "#E7E7ED",
      polygonFill: "#F5F7F9",
      lineWidth: 2,
      shadowBlur: 4,
      shadowColor: "rgba(198,199,200, 0.5)",
      shadowOffsetX: 2,
      shadowOffsetY: 6,
    },
  },
  {
    featureType: "unit",
    elementType: "geometry",
    symbol: {
      lineColor: "#969696",
      lineWidth: 2,
      polygonFill: "#CECECE",
    },
  },
  {
    featureType: "unit.elevator",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.restroom",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.restroom.female",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.restroom.male",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.mothersroom",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.privatelounge",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "footprint",
    elementType: "material",
    symbol: {
      color: "#b3aca9",
      transparent: true,
    },
  },
  {
    featureType: "unit.escalator",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.elevator",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.stairs",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.stairs.emergencyexit",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.walkway",
    elementType: "geometry",
    symbol: {
      lineColor: "#969696",
      polygonFill: "#969696",
    },
  },
  {
    featureType: "unit.footbridge",
    elementType: "geometry",
    symbol: {
      lineColor: "#969696",
      polygonFill: "#969696",
    },
  },
  {
    featureType: "unit.room",
    elementType: "geometry",
    symbol: {
      lineColor: "#969696",
      lineWidth: 2,
      polygonFill: "#CECECE",
      polygonOpacity: 0.7,
    },
  },
  {
    featureType: "unit.parking",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#f0f0f0",
    },
  },
  {
    featureType: "unit.nonpublic",
    elementType: "geometry",
    symbol: {
      lineWidth: 1,
      lineColor: "#D7D7D7",
      polygonFill: "#F7F7F7",
    },
  },
  // Unit structure (e.g., Wall, Column) and its material categories.
  {
    featureType: "unit.structure",
    elementType: "geometry",
    symbol: {
      lineWidth: 1,
      lineColor: "#c4c6d0",
      polygonFill: "#c4c6d0",
    },
  },
  {
    featureType: "unit.brick",
    elementType: "geometry",
    symbol: {
      lineWidth: 1,
      lineColor: "#c4c6d0",
      polygonFill: "#c4c6d0",
    },
  },
  {
    featureType: "unit.concrete",
    elementType: "geometry",
    symbol: {
      lineWidth: 1,
      lineColor: "#c4c6d0",
      polygonFill: "#c4c6d0",
    },
  },
  {
    featureType: "unit.drywall",
    elementType: "geometry",
    symbol: {
      lineWidth: 1,
      lineColor: "#c4c6d0",
      polygonFill: "#c4c6d0",
    },
  },
  {
    featureType: "unit.glass",
    elementType: "geometry",
    symbol: {
      lineWidth: 1,
      lineColor: "#c4c6d0",
      polygonFill: "#c4c6d0",
    },
  },
  {
    featureType: "unit.wood",
    elementType: "geometry",
    symbol: {
      lineWidth: 1,
      lineColor: "#c4c6d0",
      polygonFill: "#c4c6d0",
    },
  },
  {
    featureType: "unit.column",
    elementType: "geometry",
    symbol: {
      lineWidth: 1,
      lineColor: "#c4c6d0",
      polygonFill: "#c4c6d0",
    },
  },
  {
    // Not a physical extent from floor to ceiling.
    featureType: "fixture.wall",
    elementType: "geometry",
    symbol: {
      lineWidth: 1,
      lineColor: "#c4c6d0",
      polygonFill: "#c4c6d0",
    },
  },
  // End of unit structure and its material categories.
  {
    featureType: "unit.opentobelow",
    elementType: "geometry",
    symbol: {
      lineWidth: 0,
      lineColor: "transparent",
      polygonFill: "transparent",
    },
  },
  {
    featureType: "unit.ramp",
    elementType: "geometry",
    symbol: {
      lineWidth: 1,
      lineColor: "#969696",
      polygonFill: "#969696",
    },
  },
  {
    featureType: "kiosk",
    elementType: "geometry",
    symbol: {
      lineColor: "#969696",
      polygonFill: "#CECECE",
      polygonOpacity: 0.7,
      lineWidth: 2,
    },
  },
  {
    featureType: "fixture",
    elementType: "geometry",
    symbol: {
      lineColor: "#969696",
      polygonFill: "#CECECE",
      polygonOpacity: 0.7,
      lineWidth: 2,
    },
  },
  {
    featureType: "fixture.vegetation",
    elementType: "geometry",
    symbol: {
      polygonFill: "#A3D220",
      polygonOpacity: 0.7,
      lineWidth: 0,
    },
  },
  {
    featureType: "fixture.water",
    elementType: "geometry",
    symbol: {
      lineWidth: 0,
      polygonFill: "#56ACDF",
      polygonOpacity: 0.7,
    },
  },
  {
    featureType: "opening",
    elementType: "geometry",
    symbol: {
      lineWidth: {
        stops: [
          [18, 0],
          [19, 1],
          [20, 5],
        ],
      },
    },
  },
  {
    featureType: "decoration",
    elementType: "geometry",
    symbol: {
      lineWidth: 0.5,
      lineColor: "#CECECE",
    },
  },
  {
    featureType: "opening.pedestrian",
    elementType: "geometry",
    symbol: {
      lineColor: "#CECECE",
    },
  },
  {
    featureType: "opening.pedestrian.principal",
    elementType: "geometry",
    symbol: {
      lineColor: "#333333",
    },
  },
  {
    featureType: "opening.emergencyexit",
    elementType: "geometry",
    symbol: {
      lineColor: "#333333",
    },
  },
  // Opening marker for emergency exit
  {
    featureType: "opening",
    elementType: "label.base",
    symbol: {
      markerType: "path",
      markerPath:
        "M20 5.33333C20 4.59695 19.4031 4 18.6667 4H5.33333C4.59695 4 4 4.59695 4 5.33333V18.6667C4 19.4031 4.59695 20 5.33333 20H18.6667C19.4031 20 20 19.4031 20 18.6667V5.33333Z",
      markerPathWidth: 24,
      markerPathHeight: 24,
      markerWidth: 30,
      markerHeight: 30,
      markerFill: "#01a145",
    },
  },
  {
    featureType: "opening",
    elementType: "label.marker",
    symbol: {
      markerType: "path",
      markerFill: "#FFFFFF",
      markerPathWidth: 24,
      markerPathHeight: 24,
      markerWidth: 24,
      markerHeight: 24,
      markerDy: 3,
      markerDx: 3,
    },
  },
  {
    featureType: "highlighted-opening",
    elementType: "label.base",
    symbol: {
      markerFill: "#f65751",
    },
  },
  {
    featureType: "highlighted-opening",
    elementType: "label.marker",
    symbol: {
      markerFill: "#FFFFFF",
    },
  },
  {
    featureType: "opening.emergencyexit",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("opening.emergencyexit"),
    },
  },
  {
    featureType: "section",
    elementType: "geometry",
    symbol: {
      textFaceName: BASE_FONT_FAMILY,
      lineColor: "transparent",
      lineWidth: 1,
      polygonFill: "transparent",
    },
  },
  {
    featureType: "section.eatingdrinking",
    elementType: "geometry",
    symbol: {},
  },
  {
    featureType: "section.vegetation",
    elementType: "geometry",
    symbol: {
      lineColor: "#A4B494",
      polygonFill: "#A4B494",
    },
  },
  {
    featureType: "section.seating",
    elementType: "geometry",
    symbol: {
      lineColor: "#A4B494",
      polygonFill: "#A4B494",
    },
  },
  {
    featureType: "section.parking",
    elementType: "geometry",
    symbol: {
      lineColor: "#A4B494",
      polygonFill: "#b7A280",
    },
    options: {},
  },
  {
    featureType: "amenity",
    elementType: "label.base",
    symbol: {
      markerType: "path",
      markerPath: "M21.75 0H0.25V21.5H8.35L11.3 24L14.2 21.5H21.75V0Z",
      markerPathWidth: 24,
      markerPathHeight: 24,
      markerWidth: 30,
      markerHeight: 30,
      markerFill: "#044B7F",
    },
  },
  {
    featureType: "amenity",
    elementType: "label.marker",
    symbol: {
      markerType: "path",
      markerFill: "#FFFFFF",
      markerPathWidth: 24,
      markerPathHeight: 24,
      markerWidth: 24,
      markerHeight: 24,
      markerDy: 1.5,
      markerDx: 1.5,
    },
  },
  {
    featureType: "highlighted-amenity",
    elementType: "label.base",
    symbol: {
      markerFill: "#f65751",
    },
  },
  {
    featureType: "highlighted-amenity",
    elementType: "label.marker",
    symbol: {
      markerFill: "#FFFFFF",
    },
  },
  {
    featureType: "highlighted-occupant",
    elementType: "label.marker",
    symbol: {
      markerFill: "#f65751",
    },
  },
  {
    featureType: "highlighted-occupant",
    elementType: "label.base",
    symbol: {
      markerFill: "#FFFFFF",
    },
  },
  {
    featureType: "occupant",
    elementType: "label.base",
    symbol: {
      markerType: "path",
      markerPath: "M21.75 0H0.25V21.5H8.35L11.3 24L14.2 21.5H21.75V0Z",
      markerPathWidth: 24,
      markerPathHeight: 24,
      markerWidth: 30,
      markerHeight: 30,
      markerFill: "#044B7F",
    },
  },
  {
    featureType: "occupant",
    elementType: "label.marker",
    symbol: {
      markerType: "path",
      markerFill: "#FFFFFF",
      markerPathWidth: 24,
      markerPathHeight: 24,
      markerWidth: 24,
      markerHeight: 24,
      markerDy: 1.5,
      markerDx: 1.5,
    },
  },
  {
    featureType: "amenity.elevator",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.elevator"),
    },
  },
  {
    featureType: "amenity.escalator",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.escalator"),
    },
  },
  {
    featureType: "amenity.information",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.information"),
    },
  },
  {
    featureType: "amenity.reception.desk",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.reception.desk"),
    },
  },
  {
    featureType: "amenity.atm",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.atm"),
    },
  },
  {
    featureType: "amenity.stairs",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.stairs"),
    },
  },
  {
    featureType: "amenity.stairs.emergencyexit",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.stairs.emergencyexit"),
    },
  },
  {
    featureType: "amenity.emergencyshelter",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.emergencyshelter"),
    },
  },
  {
    featureType: "amenity.currencyexchange",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.currencyexchange"),
    },
  },
  {
    featureType: "amenity.restroom",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.restroom"),
    },
  },
  {
    featureType: "amenity.restroom.male",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.restroom.male"),
    },
  },
  {
    featureType: "amenity.restroom.female",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.restroom.female"),
    },
  },
  {
    featureType: "amenity.restroom.wheelchair",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.restroom.wheelchair"),
    },
  },
  {
    featureType: "amenity.restroom.family",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.restroom.family"),
    },
  },
  {
    featureType: "amenity.shower",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.shower"),
    },
  },
  {
    featureType: "amenity.parking",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.parking"),
    },
  },
  {
    featureType: "amenity.parking.shortterm",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.parking.shortterm"),
    },
  },
  {
    featureType: "amenity.parking.longterm",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.parking.longterm"),
    },
  },
  {
    featureType: "amenity.parking.waitingarea",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.parking.waitingarea"),
    },
  },
  {
    featureType: "amenity.parking.compact",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.parking.compact"),
    },
  },
  {
    featureType: "amenity.parking.ev",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.parking.ev"),
    },
  },
  {
    featureType: "amenity.animalreliefarea",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.animalreliefarea"),
    },
  },
  {
    featureType: "amenity.guestservices",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.guestservices"),
    },
  },

  {
    featureType: "amenity.changemachine",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.changemachine"),
    },
  },
  {
    featureType: "amenity.prayerroom",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.prayerroom"),
    },
  },
  {
    featureType: "amenity.prayerroom.islam.female",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.prayerroom.islam.female"),
    },
  },
  {
    featureType: "amenity.prayerroom.islam.male",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.prayerroom.islam.male"),
    },
  },
  {
    featureType: "amenity.firstaid",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.firstaid"),
    },
  },
  {
    featureType: "amenity.smokingarea",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.smokingarea"),
    },
  },
  {
    featureType: "amenity.bus",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.bus"),
    },
  },
  {
    featureType: "amenity.bus.muni",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.bus.muni"),
    },
  },
  {
    featureType: "amenity.shuttle",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.shuttle"),
    },
  },
  {
    featureType: "amenity.transit",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.transit"),
    },
  },
  {
    featureType: "amenity.pedestriancrossing",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.pedestriancrossing"),
    },
  },
  {
    featureType: "amenity.taxi",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.taxi"),
    },
  },
  {
    featureType: "amenity.groundtransportation",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.groundtransportation"),
    },
  },
  {
    featureType: "amenity.parking.bicycle",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.parking.bicycle"),
    },
  },
  {
    featureType: "amenity.parking.motorcycle",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.parking.motorcycle"),
    },
  },
  {
    featureType: "amenity.wheelchair",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.wheelchair"),
    },
  },
  {
    featureType: "amenity.landmark",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.landmark"),
    },
  },
  {
    featureType: "amenity.rail.muni",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.rail.muni"),
    },
  },

  {
    featureType: "amenity.boardinggate.ferry",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.boardinggate.ferry"),
    },
  },
  {
    featureType: "amenity.ticketing",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.ticketing"),
    },
  },
  {
    featureType: "amenity.meetingpoint",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.meetingpoint"),
    },
  },
  {
    featureType: "amenity.exhibit",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.exhibit"),
    },
  },
  {
    featureType: "amenity.coinlocker",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.coinlocker"),
    },
  },
  {
    featureType: "amenity.powerchargingstation",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.powerchargingstation"),
    },
  },
  {
    featureType: "amenity.wheelchairassit",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.wheelchairassit"),
    },
  },
  {
    featureType: "amenity.babychanging",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.babychanging"),
    },
  },
  {
    featureType: "amenity.mothersroom",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.mothersroom"),
    },
  },
  {
    featureType: "amenity.checkin.desk",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.checkin.desk"),
    },
  },
  {
    featureType: "amenity.strollerrental",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.strollerrental"),
    },
  },
  {
    featureType: "amenity.privatelounge",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.privatelounge"),
    },
  },
  {
    featureType: "amenity.rideshare",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.rideshare"),
    },
  },
  {
    featureType: "amenity.valet",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.valet"),
    },
  },
  {
    featureType: "amenity.service",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.service"),
    },
  },
  {
    featureType: "amenity.ticketing.rail",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.ticketing.rail"),
    },
  },
  {
    featureType: "amenity.baggagestorage",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.baggagestorage"),
    },
  },
  {
    featureType: "amenity.library",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.library"),
    },
  },
  {
    featureType: "amenity.lostandfound",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.lostandfound"),
    },
  },
  {
    featureType: "amenity.foodservice",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.foodservice"),
    },
  },
  {
    featureType: "amenity.vendingmachine",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.vendingmachine"),
    },
  },
  {
    featureType: "amenity.businesscenter",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.businesscenter"),
    },
  },
  {
    featureType: "occupant.bank",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("occupant.bank"),
    },
  },
  {
    featureType: "occupant.postoffice",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("occupant.postoffice"),
    },
  },
  {
    featureType: "occupant.books",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("occupant.books"),
    },
  },
  {
    featureType: "occupant.currencyexchange",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("occupant.currencyexchange"),
    },
  },
  {
    featureType: "occupant.donationcenter",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("occupant.donationcenter"),
    },
  },
  {
    featureType: "amenity.prayerroom.buddhism",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.prayerroom.buddhism"),
    },
  },
  {
    featureType: "amenity.defibrillator",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.defibrillator"),
    },
  },
  {
    featureType: "amenity.drinkingfountain",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.drinkingfountain"),
    },
  },
  {
    featureType: "amenity.handsanitizerstation",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.handsanitizerstation"),
    },
  },
  {
    featureType: "amenity.unspecified",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.unspecified"),
    },
  },
  {
    featureType: "amenity.entry",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.entry"),
    },
  },
  {
    featureType: "amenity.fireextinguisher",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.fireextinguisher"),
    },
  },
  {
    featureType: "amenity.security",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.security"),
    },
  },
  {
    featureType: "amenity.seating",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.seating"),
    },
  },
  {
    featureType: "amenity.recreation",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.recreation"),
    },
  },
  {
    featureType: "amenity.movingwalkway",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.movingwalkway"),
    },
  },
  {
    featureType: "amenity.copymachine",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.copymachine"),
    },
  },
  {
    featureType: "amenity.fieldofplay",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.fieldofplay"),
    },
  },
  {
    featureType: "amenity.fieldofplay.soccer",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.fieldofplay.soccer"),
    },
  },
  {
    featureType: "amenity.fieldofplay.tennis",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.fieldofplay.tennis"),
    },
  },
  {
    featureType: "amenity.amphitheater",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.amphitheater"),
    },
  },
  {
    featureType: "amenity.hoteling",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("amenity.hoteling"),
    },
  },
  {
    featureType: "section",
    elementType: "label.marker",
    symbol: {
      markerType: "path",
      markerFill: "#FFFFFF",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 31,
      markerHeight: 31,
      markerDy: -5,
      markerFitToBbox: true,
    },
  },
  // Per-tier entries for the 3D section-icon render path, parallel to section-logo-X.
  // Each carries the full bubble symbol + per-tier sizing.
  {
    featureType: "section-icon-1",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 88,
      markerHeight: 88,
      markerFill: "#044B7F",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
    },
  },
  {
    featureType: "section-icon-2",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 79,
      markerHeight: 79,
      markerFill: "#044B7F",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
    },
  },
  {
    featureType: "section-icon-3",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 69,
      markerHeight: 69,
      markerFill: "#044B7F",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
    },
  },
  {
    featureType: "section-icon-4",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 61,
      markerHeight: 61,
      markerFill: "#044B7F",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
    },
  },
  {
    featureType: "section-icon-5",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 53,
      markerHeight: 53,
      markerFill: "#044B7F",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
    },
  },
  {
    featureType: "section-icon-1",
    elementType: "label.marker",
    symbol: { markerWidth: 48, markerHeight: 48, markerDy: -5.5 },
  },
  {
    featureType: "section-icon-2",
    elementType: "label.marker",
    symbol: { markerWidth: 43.09, markerHeight: 43.09, markerDy: -4.94 },
  },
  {
    featureType: "section-icon-3",
    elementType: "label.marker",
    symbol: { markerWidth: 37.64, markerHeight: 37.64, markerDy: -4.31 },
  },
  {
    featureType: "section-icon-4",
    elementType: "label.marker",
    symbol: { markerWidth: 33.27, markerHeight: 33.27, markerDy: -3.81 },
  },
  {
    featureType: "section-icon-5",
    elementType: "label.marker",
    symbol: { markerWidth: 28.91, markerHeight: 28.91, markerDy: -3.31 },
  },
  {
    featureType: "highlight-section-icon-1",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 101.2,
      markerHeight: 101.2,
      markerFill: "#f65751",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
      shadowOffsetY: 6,
      shadowBlur: 16,
      shadowColor: "rgb(0 0 0 / 25%)",
    },
  },
  {
    featureType: "highlight-section-icon-1",
    elementType: "label.marker",
    symbol: {
      markerWidth: 55.2,
      markerHeight: 55.2,
      markerDy: -6.33,
      markerFill: "#FFFFFF",
    },
  },
  {
    featureType: "highlight-section-icon-2",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 90.85,
      markerHeight: 90.85,
      markerFill: "#f65751",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
      shadowOffsetY: 5,
      shadowBlur: 14,
      shadowColor: "rgb(0 0 0 / 25%)",
    },
  },
  {
    featureType: "highlight-section-icon-2",
    elementType: "label.marker",
    symbol: {
      markerWidth: 49.55,
      markerHeight: 49.55,
      markerDy: -5.68,
      markerFill: "#FFFFFF",
    },
  },
  {
    featureType: "highlight-section-icon-3",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 79.35,
      markerHeight: 79.35,
      markerFill: "#f65751",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
      shadowOffsetY: 5,
      shadowBlur: 12,
      shadowColor: "rgb(0 0 0 / 25%)",
    },
  },
  {
    featureType: "highlight-section-icon-3",
    elementType: "label.marker",
    symbol: {
      markerWidth: 43.28,
      markerHeight: 43.28,
      markerDy: -4.96,
      markerFill: "#FFFFFF",
    },
  },
  {
    featureType: "highlight-section-icon-4",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 70.15,
      markerHeight: 70.15,
      markerFill: "#f65751",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
      shadowOffsetY: 4,
      shadowBlur: 10,
      shadowColor: "rgb(0 0 0 / 25%)",
    },
  },
  {
    featureType: "highlight-section-icon-4",
    elementType: "label.marker",
    symbol: {
      markerWidth: 38.26,
      markerHeight: 38.26,
      markerDy: -4.38,
      markerFill: "#FFFFFF",
    },
  },
  {
    featureType: "highlight-section-icon-5",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 60.95,
      markerHeight: 60.95,
      markerFill: "#f65751",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
      shadowOffsetY: 3,
      shadowBlur: 8,
      shadowColor: "rgb(0 0 0 / 25%)",
    },
  },
  {
    featureType: "highlight-section-icon-5",
    elementType: "label.marker",
    symbol: {
      markerWidth: 33.25,
      markerHeight: 33.25,
      markerDy: -3.81,
      markerFill: "#FFFFFF",
    },
  },
  {
    featureType: "section.parking",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("section.parking"),
    },
  },
  {
    featureType: "section.parking.bicycle",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("section.parking.bicycle"),
    },
  },
  {
    featureType: "section.parking.compact",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("section.parking.compact"),
    },
  },
  {
    featureType: "section.parking.ev",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("section.parking.ev"),
    },
  },
  {
    featureType: "section.parking.longterm",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("section.parking.longterm"),
    },
  },
  {
    featureType: "section.parking.motorcycle",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("section.parking.motorcycle"),
    },
  },
  {
    featureType: "section.parking.shortterm",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("section.parking.shortterm"),
    },
  },
  {
    featureType: "section.parking.waitingarea",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("section.parking.waitingarea"),
    },
  },
  {
    featureType: "section.exhibit",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("section.exhibit"),
    },
  },
  {
    featureType: "section.information",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("section.information"),
    },
  },
  {
    featureType: "section.recreation",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("section.recreation"),
    },
  },
  {
    featureType: "section.seating",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("section.seating"),
    },
  },
  {
    featureType: "section.security",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("section.security"),
    },
  },
  {
    featureType: "section.ticketing",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("section.ticketing"),
    },
  },

  {
    featureType: "highlighted-section",
    elementType: "label.marker",
    symbol: {
      markerFill: "#FFFFFF",
    },
  },
  {
    featureType: "highlighted-section",
    elementType: "label.base",
    options: {
      scale: 0.025,
      altitude: 5,
    },
    symbol: {
      markerFill: "#f65751",
    },
  },
  {
    featureType: "highlight-occupant-logo",
    elementType: "label.base",
    symbol: {
      markerType: "path",
      markerPath:
        "M7.37608 0C3.30239 0 0 3.30239 0 7.37608V36.0859C0 40.1596 3.30239 43.4621 7.37608 43.4621H15.6185L23.0053 54.4285L30.392 43.4621H38.6238C42.6975 43.4621 46 40.1596 46 36.0859V7.37608C46 3.30239 42.6975 0 38.6238 0H7.37608Z",
      markerPathWidth: 46,
      markerPathHeight: 54,
      markerWidth: {
        stops: [
          [18, 46],
          [20, 58],
          [22, 72],
        ],
      },
      markerHeight: {
        stops: [
          [18, 54],
          [20, 68],
          [22, 84],
        ],
      },
      markerFill: "#fff",
      shadowOffsetY: 8,
      shadowBlur: 20,
      shadowColor: "rgb(35 31 32 / 30%)",
    },
  },
  {
    featureType: "highlight-occupant-logo",
    elementType: "label.marker",
    symbol: {
      markerWidth: {
        stops: [
          [18, 34],
          [20, 42],
          [22, 56],
        ],
      },
      markerHeight: {
        stops: [
          [18, 34],
          [20, 42],
          [22, 56],
        ],
      },
      markerDy: {
        stops: [
          [18, -16],
          [20, -20],
          [22, -22],
        ],
      },
    },
  },
  {
    featureType: "highlight-section-logo",
    elementType: "label.base",
    symbol: {
      markerType: "path",
      markerPath:
        "M7.37608 0C3.30239 0 0 3.30239 0 7.37608V36.0859C0 40.1596 3.30239 43.4621 7.37608 43.4621H15.6185L23.0053 54.4285L30.392 43.4621H38.6238C42.6975 43.4621 46 40.1596 46 36.0859V7.37608C46 3.30239 42.6975 0 38.6238 0H7.37608Z",
      markerPathWidth: 46,
      markerPathHeight: 54,
      markerWidth: {
        stops: [
          [18, 46],
          [20, 58],
          [22, 72],
        ],
      },
      markerHeight: {
        stops: [
          [18, 54],
          [20, 68],
          [22, 84],
        ],
      },
      markerFill: "#fff",
      shadowOffsetY: 8,
      shadowBlur: 20,
      shadowColor: "rgb(35 31 32 / 30%)",
    },
  },
  {
    featureType: "highlight-section-logo",
    elementType: "label.marker",
    symbol: {
      markerWidth: {
        stops: [
          [18, 34],
          [20, 42],
          [22, 56],
        ],
      },
      markerHeight: {
        stops: [
          [18, 34],
          [20, 42],
          [22, 56],
        ],
      },
      markerDy: {
        stops: [
          [18, -16],
          [20, -20],
          [22, -22],
        ],
      },
    },
  },
  {
    featureType: "occupant-logo-1",
    elementType: "label.base",
    symbol: {
      markerType: "path",
      markerPath: "M45.5 0h-43v43h16.2l5.9 5 5.8-5h15.1z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: {
        stops: [
          [18, 30],
          [19, 32],
          [20, 36],
          [21, 36],
          [22, 40],
        ],
      },
      markerHeight: {
        stops: [
          [18, 30],
          [19, 32],
          [20, 36],
          [21, 36],
          [22, 40],
        ],
      },
      markerFill: "#044B7F",
    },
  },
  {
    featureType: "occupant-logo-1",
    elementType: "label.marker",
    symbol: {
      markerWidth: {
        stops: [
          [18, 24],
          [19, 26],
          [20, 28],
          [21, 28],
          [22, 32],
        ],
      },
      markerHeight: {
        stops: [
          [18, 24],
          [19, 26],
          [20, 28],
          [21, 28],
          [22, 32],
        ],
      },
      markerDy: -6,
    },
  },
  {
    featureType: "occupant-logo-2",
    elementType: "label.base",
    symbol: {
      markerType: "path",
      markerPath: "M45.5 0h-43v43h16.2l5.9 5 5.8-5h15.1z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: {
        stops: [
          [18, 0],
          [19, 32],
          [20, 36],
          [21, 36],
          [22, 40],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 32],
          [20, 36],
          [21, 36],
          [22, 40],
        ],
      },
      markerFill: "#044B7F",
    },
  },
  {
    featureType: "occupant-logo-2",
    elementType: "label.marker",
    symbol: {
      markerWidth: {
        stops: [
          [18, 0],
          [19, 26],
          [20, 28],
          [21, 28],
          [22, 32],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 26],
          [20, 28],
          [21, 28],
          [22, 32],
        ],
      },
      markerDy: -6,
    },
  },
  {
    featureType: "occupant-logo-3",
    elementType: "label.base",
    symbol: {
      markerType: "path",
      markerPath: "M45.5 0h-43v43h16.2l5.9 5 5.8-5h15.1z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 36],
          [21, 36],
          [22, 40],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 36],
          [21, 36],
          [22, 40],
        ],
      },
      markerFill: "#044B7F",
    },
  },
  {
    featureType: "occupant-logo-3",
    elementType: "label.marker",
    symbol: {
      markerWidth: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 28],
          [21, 28],
          [22, 32],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 28],
          [21, 28],
          [22, 32],
        ],
      },
      markerDy: -6,
    },
  },
  {
    featureType: "occupant-logo-4",
    elementType: "label.base",
    symbol: {
      markerType: "path",
      markerPath: "M45.5 0h-43v43h16.2l5.9 5 5.8-5h15.1z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 36],
          [22, 40],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 36],
          [22, 40],
        ],
      },
      markerFill: "#044B7F",
    },
  },
  {
    featureType: "occupant-logo-4",
    elementType: "label.marker",
    symbol: {
      markerWidth: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 28],
          [22, 32],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 28],
          [22, 32],
        ],
      },
      markerDy: -6,
    },
  },
  {
    featureType: "occupant-logo-5",
    elementType: "label.base",
    symbol: {
      markerType: "path",
      markerPath: "M45.5 0h-43v43h16.2l5.9 5 5.8-5h15.1z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 0],
          [22, 40],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 0],
          [22, 40],
        ],
      },
      markerFill: "#044B7F",
    },
  },
  {
    featureType: "occupant-logo-5",
    elementType: "label.marker",
    symbol: {
      markerWidth: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 0],
          [22, 32],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 0],
          [22, 32],
        ],
      },
      markerDy: -6,
    },
  },
  {
    featureType: "section-logo-1",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 88,
      markerHeight: 88,
      markerFill: "#044B7F",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
    },
  },
  {
    featureType: "section-logo-1",
    elementType: "label.marker",
    symbol: {
      markerWidth: 58,
      markerHeight: 58,
      markerDy: -9.35,
    },
  },
  {
    featureType: "section-logo-2",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 79,
      markerHeight: 79,
      markerFill: "#044B7F",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
    },
  },
  {
    featureType: "section-logo-2",
    elementType: "label.marker",
    symbol: {
      markerWidth: 51,
      markerHeight: 51,
      markerDy: -8.65,
    },
  },
  {
    featureType: "section-logo-3",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 69,
      markerHeight: 69,
      markerFill: "#044B7F",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
    },
  },
  {
    featureType: "section-logo-3",
    elementType: "label.marker",
    symbol: {
      markerWidth: 45,
      markerHeight: 45,
      markerDy: -7.55,
    },
  },
  {
    featureType: "section-logo-4",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 61,
      markerHeight: 61,
      markerFill: "#044B7F",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
    },
  },
  {
    featureType: "section-logo-4",
    elementType: "label.marker",
    symbol: {
      markerWidth: 40,
      markerHeight: 40,
      markerDy: -6.95,
    },
  },
  {
    featureType: "section-logo-5",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 53,
      markerHeight: 53,
      markerFill: "#044B7F",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
    },
  },
  {
    featureType: "section-logo-5",
    elementType: "label.marker",
    symbol: {
      markerWidth: 33,
      markerHeight: 33,
      markerDy: -5.95,
    },
  },
  {
    featureType: "highlight-section-logo-1",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 101.2,
      markerHeight: 101.2,
      markerFill: "#f65751",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
      shadowOffsetY: 6,
      shadowBlur: 16,
      shadowColor: "rgb(0 0 0 / 25%)",
    },
  },
  {
    featureType: "highlight-section-logo-1",
    elementType: "label.marker",
    symbol: {
      markerWidth: 66.7,
      markerHeight: 66.7,
      markerDy: -10.7525,
    },
  },
  {
    featureType: "highlight-section-logo-2",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 90.85,
      markerHeight: 90.85,
      markerFill: "#f65751",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
      shadowOffsetY: 5,
      shadowBlur: 14,
      shadowColor: "rgb(0 0 0 / 25%)",
    },
  },
  {
    featureType: "highlight-section-logo-2",
    elementType: "label.marker",
    symbol: {
      markerWidth: 58.65,
      markerHeight: 58.65,
      markerDy: -9.9475,
    },
  },
  {
    featureType: "highlight-section-logo-3",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 79.35,
      markerHeight: 79.35,
      markerFill: "#f65751",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
      shadowOffsetY: 5,
      shadowBlur: 12,
      shadowColor: "rgb(0 0 0 / 25%)",
    },
  },
  {
    featureType: "highlight-section-logo-3",
    elementType: "label.marker",
    symbol: {
      markerWidth: 51.75,
      markerHeight: 51.75,
      markerDy: -8.6825,
    },
  },
  {
    featureType: "highlight-section-logo-4",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 70.15,
      markerHeight: 70.15,
      markerFill: "#f65751",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
      shadowOffsetY: 4,
      shadowBlur: 10,
      shadowColor: "rgb(0 0 0 / 25%)",
    },
  },
  {
    featureType: "highlight-section-logo-4",
    elementType: "label.marker",
    symbol: {
      markerWidth: 46,
      markerHeight: 46,
      markerDy: -7.9925,
    },
  },
  {
    featureType: "highlight-section-logo-5",
    elementType: "label.base",
    symbol: {
      markerPath:
        "M2.5 6a6 6 0 0 1 6-6h31a6 6 0 0 1 6 6v31a6 6 0 0 1-6 6h-9.1l-5.8 5-5.9-5h-10.2a6 6 0 0 1-6-6z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 60.95,
      markerHeight: 60.95,
      markerFill: "#f65751",
      markerStroke: "#FFFFFF",
      markerStrokeWidth: 2,
      shadowOffsetY: 3,
      shadowBlur: 8,
      shadowColor: "rgb(0 0 0 / 25%)",
    },
  },
  {
    featureType: "highlight-section-logo-5",
    elementType: "label.marker",
    symbol: {
      markerWidth: 37.95,
      markerHeight: 37.95,
      markerDy: -6.8425,
    },
  },
  {
    featureType: "occupant-name",
    elementType: "ui.marker",
    symbol: {
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 2,
      overflow: "hidden",
      WebkitBoxPack: "center",
      WebkitBoxAlign: "center",
      width: "200px",
      textOverflow: "ellipsis",
      paintOrder: "stroke",
      WebkitTextStrokeWidth: "5px",
      WebkitTextStrokeColor: "#fff",
      fontFamily: "Manrope",
      textAlign: "center",
    },
  },
  {
    featureType: "section-name",
    elementType: "ui.marker",
    symbol: {
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 2,
      overflow: "hidden",
      WebkitBoxPack: "center",
      WebkitBoxAlign: "center",
      width: "200px",
      textOverflow: "ellipsis",
      paintOrder: "stroke",
      WebkitTextStrokeWidth: "5px",
      WebkitTextStrokeColor: "#fff",
      fontFamily: "Manrope",
      textAlign: "center",
    },
  },
  // === UI Marker ===
  {
    featureType: "occupant-name-1",
    elementType: "ui.marker",
    symbol: {
      fontSize: "20px",
    },
    options: {
      maxZoom: null,
      minZoom: 0,
    },
  },
  {
    featureType: "occupant-name-2",
    elementType: "ui.marker",
    symbol: {
      fontSize: "18px",
    },
    options: {
      maxZoom: null,
      minZoom: 19,
    },
  },
  {
    featureType: "occupant-name-3",
    elementType: "ui.marker",
    symbol: {
      fontSize: "16px",
    },
    options: {
      maxZoom: null,
      minZoom: 20,
    },
  },
  {
    featureType: "occupant-name-4",
    elementType: "ui.marker",
    symbol: {
      fontSize: "14px",
    },
    options: {
      maxZoom: null,
      minZoom: 21,
    },
  },
  {
    featureType: "occupant-name-5",
    elementType: "ui.marker",
    symbol: {
      fontSize: "12px",
    },
    options: {
      maxZoom: null,
      minZoom: 22,
    },
  },
  {
    featureType: "section-name-1",
    elementType: "ui.marker",
    symbol: {
      fontSize: "20px",
    },
    options: {
      maxZoom: null,
      minZoom: 0,
    },
  },
  {
    featureType: "section-name-2",
    elementType: "ui.marker",
    symbol: {
      fontSize: "18px",
    },
    options: {
      maxZoom: null,
      minZoom: 19,
    },
  },
  {
    featureType: "section-name-3",
    elementType: "ui.marker",
    symbol: {
      fontSize: "16px",
    },
    options: {
      maxZoom: null,
      minZoom: 20,
    },
  },
  {
    featureType: "section-name-4",
    elementType: "ui.marker",
    symbol: {
      fontSize: "14px",
    },
    options: {
      maxZoom: null,
      minZoom: 21,
    },
  },
  {
    featureType: "section-name-5",
    elementType: "ui.marker",
    symbol: {
      fontSize: "12px",
    },
    options: {
      maxZoom: null,
      minZoom: 22,
    },
  },
  // === End UI Marker ===
  // === Text Marker ===
  {
    featureType: "occupant-name",
    elementType: "label.marker",
    symbol: {
      textFaceName: BASE_FONT_FAMILY,
      textWeight: "normal",
      textStyle: "normal",
      textFill: "#666666",
      textHaloFill: "#ffffff",
      textLineSpacing: 6,
    },
  },
  {
    featureType: "occupant-name-1",
    elementType: "label.marker",
    symbol: {
      textSize: 20,
      opacity: 1,
    },
  },
  {
    featureType: "occupant-name-2",
    elementType: "label.marker",
    symbol: {
      textSize: 18,
      opacity: {
        stops: [
          [18, 0],
          [19, 1],
        ],
      },
    },
  },
  {
    featureType: "occupant-name-3",
    elementType: "label.marker",
    symbol: {
      textSize: 16,
      opacity: {
        stops: [
          [19, 0],
          [20, 1],
        ],
      },
    },
  },
  {
    featureType: "occupant-name-4",
    elementType: "label.marker",
    symbol: {
      textSize: 14,
      opacity: {
        stops: [
          [20, 0],
          [21, 1],
        ],
      },
      textHaloRadius: {
        stops: [
          [18, 0],
          [20, 1],
          [21, 2],
        ],
      },
    },
  },
  {
    featureType: "occupant-name-5",
    elementType: "label.marker",
    symbol: {
      textSize: 12,
      opacity: {
        stops: [
          [21, 0],
          [22, 1],
        ],
      },
      textHaloRadius: {
        stops: [
          [18, 0],
          [20, 0],
          [21, 2],
        ],
      },
    },
  },
  // === End Text Marker ===
  {
    featureType: "occupant-logo + name",
    elementType: "label.marker",
    symbol: {
      markerHorizontalAlignment: "left",
      markerVerticalAlignment: "middle",
      textHorizontalAlignment: "right",
      textVerticalAlignment: "middle",
      textDx: 5,
      textFaceName: BASE_FONT_FAMILY,
      textWeight: "normal",
      textStyle: "normal",
      textFill: "#666666",
      textHaloFill: "#ffffff",
      textLineSpacing: 0,
    },
  },
  {
    featureType: "occupant-logo + name-1",
    elementType: "label.marker",
    symbol: {
      textSize: {
        stops: [
          [18, 12],
          [19, 14],
          [20, 16],
          [21, 16],
          [22, 18],
        ],
      },
      markerHeight: {
        stops: [
          [18, 28],
          [19, 32],
          [20, 36],
          [21, 36],
          [22, 40],
        ],
      },
      markerWidth: {
        stops: [
          [18, 28],
          [19, 32],
          [20, 36],
          [21, 36],
          [22, 40],
        ],
      },
    },
  },
  {
    featureType: "occupant-logo + name-2",
    elementType: "label.marker",
    symbol: {
      textSize: {
        stops: [
          [18, 0],
          [19, 14],
          [20, 16],
          [21, 16],
          [22, 18],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 32],
          [20, 36],
          [21, 36],
          [22, 40],
        ],
      },
      markerWidth: {
        stops: [
          [18, 0],
          [19, 32],
          [20, 36],
          [21, 36],
          [22, 40],
        ],
      },
    },
  },
  {
    featureType: "occupant-logo + name-3",
    elementType: "label.marker",
    symbol: {
      textSize: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 16],
          [21, 16],
          [22, 18],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 35],
          [21, 35],
          [22, 40],
        ],
      },
      markerWidth: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 35],
          [21, 35],
          [22, 40],
        ],
      },
    },
  },
  {
    featureType: "occupant-logo + name-4",
    elementType: "label.marker",
    symbol: {
      textSize: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 16],
          [22, 18],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 36],
          [22, 40],
        ],
      },
      markerWidth: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 36],
          [22, 40],
        ],
      },
    },
  },
  {
    featureType: "occupant-logo + name-5",
    elementType: "label.marker",
    symbol: {
      textSize: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 0],
          [22, 18],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 0],
          [22, 40],
        ],
      },
      markerWidth: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 0],
          [22, 40],
        ],
      },
    },
  },
  {
    featureType: "section-logo + name",
    elementType: "label.marker",
    symbol: {
      markerHorizontalAlignment: "left",
      markerVerticalAlignment: "middle",
      textHorizontalAlignment: "right",
      textVerticalAlignment: "middle",
      textDx: 5,
      textFaceName: BASE_FONT_FAMILY,
      textWeight: "normal",
      textStyle: "normal",
      textFill: "#666666",
      textHaloFill: "#ffffff",
      textLineSpacing: 0,
    },
  },
  {
    featureType: "section-logo + name-1",
    elementType: "label.marker",
    symbol: {
      textSize: {
        stops: [
          [18, 12],
          [19, 14],
          [20, 16],
          [21, 16],
          [22, 18],
        ],
      },
      markerHeight: {
        stops: [
          [18, 28],
          [19, 32],
          [20, 36],
          [21, 36],
          [22, 40],
        ],
      },
      markerWidth: {
        stops: [
          [18, 28],
          [19, 32],
          [20, 36],
          [21, 36],
          [22, 40],
        ],
      },
    },
  },
  {
    featureType: "section-logo + name-2",
    elementType: "label.marker",
    symbol: {
      textSize: {
        stops: [
          [18, 0],
          [19, 14],
          [20, 16],
          [21, 16],
          [22, 18],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 32],
          [20, 36],
          [21, 36],
          [22, 40],
        ],
      },
      markerWidth: {
        stops: [
          [18, 0],
          [19, 32],
          [20, 36],
          [21, 36],
          [22, 40],
        ],
      },
    },
  },
  {
    featureType: "section-logo + name-3",
    elementType: "label.marker",
    symbol: {
      textSize: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 16],
          [21, 16],
          [22, 18],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 35],
          [21, 35],
          [22, 40],
        ],
      },
      markerWidth: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 35],
          [21, 35],
          [22, 40],
        ],
      },
    },
  },
  {
    featureType: "section-logo + name-4",
    elementType: "label.marker",
    symbol: {
      textSize: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 16],
          [22, 18],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 36],
          [22, 40],
        ],
      },
      markerWidth: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 36],
          [22, 40],
        ],
      },
    },
  },
  {
    featureType: "section-logo + name-5",
    elementType: "label.marker",
    symbol: {
      textSize: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 0],
          [22, 18],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 0],
          [22, 40],
        ],
      },
      markerWidth: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 0],
          [21, 0],
          [22, 40],
        ],
      },
    },
  },
  {
    featureType: "highlighted-logo-marker",
    elementType: "label.base",
    symbol: {
      markerType: "path",
      markerPath:
        "M10.5049 0C6.91234 0 4 2.91234 4 6.5049V31.8239C4 35.4164 6.91234 38.3288 10.5049 38.3288H17.7738L24.2881 48L30.8024 38.3288H38.0621C41.6546 38.3288 44.567 35.4164 44.567 31.8239V6.5049C44.567 2.91234 41.6546 0 38.0621 0H10.5049Z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: {
        stops: [
          [18, 24],
          [19, 48],
          [20, 72],
        ],
      },
      markerHeight: {
        stops: [
          [18, 24],
          [19, 48],
          [20, 72],
        ],
      },
      markerFill: "#FFF",
      shadowBlur: 20,
      shadowColor: "rgba(0, 0, 0, 0.2)",
      shadowOffsetY: 8,
    },
  },
  {
    featureType: "highlighted-logo-marker",
    elementType: "label.marker",
    symbol: {
      markerWidth: {
        stops: [
          [18, 17],
          [19, 34],
          [20, 50],
        ],
      },
      markerHeight: {
        stops: [
          [18, 17],
          [19, 34],
          [20, 50],
        ],
      },
      markerDy: {
        stops: [
          [18, -7],
          [19, -12],
          [20, -18],
        ],
      },
    },
  },
  {
    featureType: "highlighted-marker",
    elementType: "geometry",
    symbol: [
      {
        markerWidth: {
          stops: [
            [18, 30],
            [19, 35],
            [20, 45],
          ],
        },
        markerHeight: {
          stops: [
            [18, 30],
            [19, 35],
            [20, 45],
          ],
        },
        markerFill: "#C60000",
      },
      {
        markerWidth: {
          stops: [
            [18, 20],
            [19, 25],
            [20, 35],
          ],
        },
        markerHeight: {
          stops: [
            [18, 20],
            [19, 25],
            [20, 35],
          ],
        },
        markerDy: -7,
      },
    ],
  },
  {
    featureType: "ground-label",
    elementType: "geometry",
    symbol: {
      fontFamily: BASE_FONT_FAMILY,
    },
  },
  // ground-label-occupant style ( render_type === 'Label')
  {
    featureType: "occupant-flat-label",
    elementType: "geometry",
    symbol: {
      fontFamily: BASE_FONT_FAMILY,
      fontSize: 12,
      lineWidth: 12,
      fillStyle: "#494656",
      strokeStyle: "#ffffff",
    },
    options: {
      maxLabelScale: 2.5, // limit max scale ( limit max font size when scaled by unit area )
    },
  },
  {
    featureType: "user-location",
    elementType: "ui.marker",
    symbol: {
      //add background:"url(marker.gif)" to make ui.marker visible
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      height: "100px",
      width: "100px",
    },
  },
]

// === Section zoom-fade (extruded sections) ===
// An extruded section (see featureExtrudeConfig in IndoorMap.class.ts) fades
// out on zoom — revealing the units beneath — whenever its
// "section-<render_priority>" geometry symbol defines `polygonOpacity.stops`
// (maptalks `stops` curve: [[zoom, opacity], ...], ascending zoom). This is
// driven by the generic zoom-style engine (see ZOOM_STYLE_TOKENS in
// utils/zoomStyle.ts / #applyStyleOnZoom in IndoorMap.class.ts), not by
// render_type — render_type only picks the section's marker.
//
// No stops ship by default here, so fading is opt-in per venue: add
// `symbol: { polygonOpacity: { stops: [...] } }` to a venue's map.json
// "section-<priority>" (1..5) entry to enable it for that tier. The stops are
// the literal material opacity values (ascending zoom) — the theme is the
// single source of truth for the fade ceiling, not app code — and `flipZoom`
// (the lowest zoom at which the curve reaches opacity 0) drives click-through
// to the units beneath once the body has fully faded (see handleClickElement).

export const getSectionStops = (renderPriority = 3, mapTheme = {}) => {
  const stops =
    mapTheme?.[`section-${renderPriority}`]?.geometry?.symbol?.polygonOpacity
      ?.stops
  return (
    stops || mapTheme?.["section-3"]?.geometry?.symbol?.polygonOpacity?.stops
  )
}

// Full symbol token bag for a section tier (not just the opacity stops), so
// any zoom-drivable token on it (see ZOOM_STYLE_TOKENS) can be compiled.
export const getSectionSymbol = (renderPriority = 3, mapTheme = {}) => {
  const symbol = mapTheme?.[`section-${renderPriority}`]?.geometry?.symbol
  return symbol || mapTheme?.["section-3"]?.geometry?.symbol
}

// Click-flip zoom = the lowest zoom at which the curve reaches opacity 0.
export const getSectionFlipZoom = (renderPriority = 3, mapTheme = {}) => {
  const stops = getSectionStops(renderPriority, mapTheme)
  const zeroStop = stops?.find(([, opacity]) => opacity === 0)
  return zeroStop ? zeroStop[0] : stops?.[stops.length - 1]?.[0]
}

export default defaultMapTheme
